// actions
import * as actions from './actions';

// initial state
const initialState = {
  initialCheckout: false,
  activeStep: 0,
  isGuestUser: true,
  deliveryAddress: false,
  checkout_step: 1,

  shippingDetails: {},
  paymentDetails: {},
  orderSummary: {
    subtotal: 0,
    shippingCost: 0,
    tax: 0,
    total: 0,
    discount: 0,
  },
  loadingStatus: false,
  errorMessages: [],
  confirmationDetails: null,
  confirmationResolved: false,
  stripe_url_checkout: null,
};

export default function checkoutReducer(state = initialState, action) {
  switch (action.type) {
    // fetch
    case actions.FETCH_CHECKOUT.REQUEST:
      return { ...state, loading: true, error: null };

    case actions.FETCH_CHECKOUT.SUCCESS:
      return { ...state, loading: false, initialCheckout: true, checkout: action.payload.checkout };

    case actions.GET_CHECKOUT_CONFIRMATION.SUCCESS:
      return { ...state, loading: false, initialCheckout: true, confirmationDetails: action.payload.confirmation, confirmationResolved: true, checkout_step: 4 };


    case actions.GET_STRIPE_CHECKOUT_URL.SUCCESS:
      return { ...state, loading: false, initialCheckout: true, stripe_url_checkout: action.payload.url };

    case actions.FETCH_CHECKOUT.FAILURE:
      return { ...state, loading: false, initialCheckout: false, error: action.payload.error };

    case actions.SET_DELIVERY_ADDRESS.REQUEST:
      return { ...state, loading: true, error: null };

    case actions.SET_DELIVERY_ADDRESS.SUCCESS:
      return { ...state, loading: false, initialCheckout: true, checkout: action.payload.checkout };

    case actions.SET_DELIVERY_ADDRESS.FAILURE:
      return { ...state, loading: false, initialCheckout: false, error: action.payload.error };






    case actions.SET_CHECKOUT_STEP.REQUEST:
      return { ...state, loading: true, error: null };

    case actions.SET_CHECKOUT_STEP.SUCCESS:
      return { ...state, loading: false, checkout_step: action.payload.step_index };

    case actions.SET_CHECKOUT_STEP.FAILURE:
      return { ...state, loading: false, error: action.payload.error };




    default:
      return state;
  }
}
